import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { LegalModal } from './ui/LegalModal';
export function ClosingSection() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      {/* Final CTA */}
      <section className="py-20 md:py-32 px-4 md:px-6 bg-gradient-to-br from-navy to-[#0A1528] relative overflow-hidden text-center" data-id="element-19">
        {/* Background Orbs */}
        <div className="absolute w-[600px] h-[600px] bg-rose rounded-full blur-[100px] opacity-10 -top-[200px] -right-[200px] pointer-events-none" data-id="element-20" />
        <div className="absolute w-[400px] h-[400px] bg-gold rounded-full blur-[100px] opacity-10 -bottom-[100px] -left-[100px] pointer-events-none" data-id="element-21" />

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-22">
          <FadeIn data-id="element-23">
            <div className="inline-block bg-gold/10 border border-gold/20 text-gold font-medium text-xs md:text-sm px-4 py-1.5 rounded-full mb-6 uppercase tracking-wider" data-id="element-24">
              🌙 Última llamada
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-black text-white leading-tight mb-6" data-id="element-25">
              No necesitas hacerlo perfecto.
              <br data-id="element-26" />
              Necesitas hacerlo
              <br data-id="element-27" />
              <span className="text-gold italic font-normal" data-id="element-28">en orden.</span>
            </h2>
            <p className="text-lg text-white/65 max-w-xl mx-auto leading-relaxed mb-12" data-id="element-29">
              Cuando tú duermes, todo mejora: tu paciencia, tu energía, tu salud
              mental y tu maternidad. Esta guía es para ayudarte a volver a ti.
            </p>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-30">
            <Button href="#pricing" className="px-10 py-5 text-lg animate-[pulse_2.5s_ease-in-out_infinite]" data-id="element-31">
              🌙 Empezar Hoy — Solo $6.39
            </Button>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-32">
            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 mt-10" data-id="element-33">
              {[{
              icon: '🔒',
              text: 'Pago 100% seguro'
            }, {
              icon: '⚡',
              text: 'Acceso inmediato'
            }, {
              icon: '🛡️',
              text: 'Garantía 7 días'
            }, {
              icon: '📱',
              text: 'Lee en cualquier dispositivo'
            }].map((item, i) => <div key={i} className="flex items-center gap-2 text-sm text-white/50" data-id="element-34">
                  <span data-id="element-35">{item.icon}</span>
                  <span data-id="element-36">{item.text}</span>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#080F20] py-10 text-center px-4" data-id="element-37">
        <div className="max-w-4xl mx-auto" data-id="element-38">
          <div className="font-serif text-lg font-bold text-white mb-2" data-id="element-39">
            Maternidad en Equilibrio
          </div>
          <div className="text-xs text-white/30 tracking-widest uppercase mb-6" data-id="element-40">
            Bienestar · Conexión · Descanso
          </div>

          <div className="flex flex-wrap justify-center gap-6 mb-6" data-id="element-41">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-white/35 hover:text-white/70 transition-colors" data-id="element-42">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-white/35 hover:text-white/70 transition-colors" data-id="element-43">
              Términos de Uso
            </button>
            <a href="#" className="text-sm text-white/35 hover:text-white/70 transition-colors" data-id="element-44">
              Contacto
            </a>
            <a href="#" className="text-sm text-white/35 hover:text-white/70 transition-colors" data-id="element-45">
              Reembolsos
            </a>
          </div>

          <p className="text-xs text-white/20 leading-relaxed" data-id="element-46">
            © {new Date().getFullYear()} Maternidad en Equilibrio. Todos los
            derechos reservados.
            <br data-id="element-47" />
            Este producto es de carácter informativo y no reemplaza la consulta
            médica profesional.
          </p>
        </div>
      </footer>

      {/* Modals */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-48">
        <p className="font-semibold text-white" data-id="element-49">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
        <p data-id="element-50">
          En <strong data-id="element-51">Maternidad en Equilibrio</strong>, respetamos tu privacidad
          y nos comprometemos a proteger tus datos personales. Esta política
          describe cómo recopilamos, usamos y protegemos tu información.
        </p>
        <h3 data-id="element-52">1. Información que recopilamos</h3>
        <p data-id="element-53">
          Recopilamos únicamente la información necesaria para procesar tu
          compra:
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-54">
          <li data-id="element-55">Nombre y dirección de correo electrónico</li>
          <li data-id="element-56">Información de pago (procesada de forma segura por terceros)</li>
        </ul>
        <h3 data-id="element-57">2. Uso de la información</h3>
        <p data-id="element-58">Utilizamos tu información para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-59">
          <li data-id="element-60">Entregar el producto digital adquirido</li>
          <li data-id="element-61">Enviar confirmación de compra y actualizaciones relevantes</li>
          <li data-id="element-62">Mejorar nuestros productos y servicios</li>
        </ul>
        <h3 data-id="element-63">3. Protección de datos</h3>
        <p data-id="element-64">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tus datos personales contra acceso no autorizado, pérdida o
          alteración.
        </p>
        <h3 data-id="element-65">4. Compartir información</h3>
        <p data-id="element-66">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu compra o
          cuando lo exija la ley.
        </p>
        <h3 data-id="element-67">5. Tus derechos</h3>
        <p data-id="element-68">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento. También puedes solicitar la limitación del
          tratamiento de tus datos.
        </p>
        <h3 data-id="element-69">6. Cookies</h3>
        <p data-id="element-70">
          Este sitio puede utilizar cookies para mejorar tu experiencia de
          navegación. Puedes configurar tu navegador para rechazar cookies si lo
          prefieres.
        </p>
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-71">
        <p className="font-semibold text-white" data-id="element-72">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
        <p data-id="element-73">
          Al adquirir la <strong data-id="element-74">"Guía del Sueño del Bebé (0 a 3 Años)"</strong>{' '}
          y el <strong data-id="element-75">Planificador de Sueño del Bebé</strong>, aceptas los
          siguientes términos y condiciones.
        </p>
        <h3 data-id="element-76">1. Producto digital</h3>
        <p data-id="element-77">
          Este es un producto digital (método + planificador) que se entrega en
          formato electrónico. Una vez realizada la compra, recibirás acceso
          inmediato al contenido.
        </p>
        <h3 data-id="element-78">2. Uso personal</h3>
        <p data-id="element-79">
          El contenido adquirido es para uso personal y privado. Queda prohibida
          la reproducción, distribución, reventa o compartición del material sin
          autorización expresa.
        </p>
        <h3 data-id="element-80">3. Propiedad intelectual</h3>
        <p data-id="element-81">
          Todo el contenido, incluyendo textos, diseños e ilustraciones, es
          propiedad de Maternidad en Equilibrio y está protegido por las leyes
          de propiedad intelectual.
        </p>
        <h3 data-id="element-82">4. Descargo de responsabilidad</h3>
        <p data-id="element-83">
          La información proporcionada en esta guía es de carácter educativo e
          informativo. No sustituye el consejo médico profesional. Consulta
          siempre con tu pediatra ante cualquier duda sobre la salud de tu bebé.
        </p>
        <h3 data-id="element-84">5. Política de reembolso</h3>
        <p data-id="element-85">
          Debido a la naturaleza digital del producto, no se aceptan
          devoluciones una vez entregado el acceso al contenido, salvo en casos
          excepcionales evaluados individualmente.
        </p>
        <h3 data-id="element-86">6. Modificaciones</h3>
        <p data-id="element-87">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          esta página.
        </p>
      </LegalModal>
    </>;
}